<template>
    <v-card>
       <v-container>
        <s-crud
            :config="config"
            title="Asignación de Buses"
            add
            @save="save($event)"
            remove
            :filter="filter"
        >
            <template v-slot:options>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      v-on="on"
                      small
                      elevation="0"
                      @click="reportExcel()"
                      :disabled="!filter.AbpStartDate || !filter.AbpEndDate"
                    >
                      <v-icon color="green darken-4" x-small> mdi-file-excel </v-icon>
                    </v-btn>
                  </template>
                  <span>Exportar a Excel</span>
                </v-tooltip>
            </template>
            <template v-slot:filter>
                <v-container>
                    <v-row>
                        <v-col>
                            <s-select
                                v-model="filter.BscID"
                                :items="dataBuses"
                                item-text="BusRoute"
                                item-value="BscID"
                                label="Bus de Personal"
                                @input="selectBus($event)"
                            />
                        </v-col>
                        <!-- filtro de fecha -->
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <s-date
                                label="Fecha"
                                v-model="filter.AbpStartDate"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3">
                            <s-date
                                label="Fecha"
                                v-model="filter.AbpEndDate"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot="props">
                <div>
                    <v-row>
                        <v-col cols="12" md="3">
                            <s-toolbar-person
                                @returnPerson="hadReturnPerson($event, props.item)"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <s-text disabled label="Nombres" v-model="
                            NtpFullName
                            " />
                        </v-col>
                        <v-col cols="12" md="3">
                            <s-select 
                                v-model="props.item.BscID"
                                :items="dataBuses"
                                item-text="BusRoute"
                                item-value="BscID"
                                label="Bus de Personal"
                                @input="selectBus($event)"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch
                                v-model="props.item.AbpIsIndefinite"
                                label="Asignación Indefinida"
                                color="primary"
                                hide-details
                            ></v-switch>
                        </v-col>
                    </v-row>
                    
                    <v-row v-if="!props.item.AbpIsIndefinite">
                        <v-col cols="12" md="6">
                            <v-menu
                                ref="menuStartDate"
                                v-model="startDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="props.item.AbpStartDate"
                                        label="Fecha Inicio"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        dense
                                        :rules="dateRules"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="props.item.AbpStartDate"
                                    @input="startDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        
                        <v-col cols="12" md="6">
                            <v-menu
                                ref="menuEndDate"
                                v-model="endDateMenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="props.item.AbpEndDate"
                                        label="Fecha Fin"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        dense
                                        :rules="dateRules"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="props.item.AbpEndDate"
                                    @input="endDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </s-crud>
       </v-container>
    </v-card>
</template>

<script>
import ServiceAssignBus from "@/services/HumanResource/HmnAssignBusPersonService";
import ServiceMonitoring from "@/services/Management/MonitoringBusService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import GenericService from "@/services/General/GenericService";

export default {
   components: {
    sToolbarPerson
   },
    data() {
        return {
            Person: "",
            item: {},
            Document: "",
            NtpFullName:"",
            PrsID: 1,
            BscID: 1,
            filter: {
                AbpStartDate: new Date().toISOString(),
                AbpEndDate: new Date().toISOString(),
            },
            startDateMenu: false,
            endDateMenu: false,
            dateRules: [
                v => !v || v.length > 0 || 'La fecha es requerida'
            ],
            config: {
                service: ServiceAssignBus,
                model: {
                    AbpID: "ID"
                },
                headers:[
                    { text: "ID", value: "AbpID" },
                    { text: "Bus", value: "BusName" },
                    { text: "DNI", value: "PrsDocumentNumber" },
                    { text: "Apellidos y Nombres", value: "FullName" },
                    { text: "Tipo", value: "TypeAssign" },
                    { text: "Fecha Inicio", value: "AbpStartDateText" },
                    { text: "Fecha Fin", value: "AbpEndDateText" }
                ]
            },
            itemsData: [],
            dataBuses: [],
            personBus: {},
            person: {
                PrsID: null
            },
            buss: null,
            WorkerAsigned: {
                headers: [
                    { text: "ID", value: "AbpID" },
                    { text: "Bus", value: "BusName" },
                    { text: "DNI", value: "PrsDocumentNumber" },
                    { text: "Apellidos y Nombres", value: "FullName" },
                    { text: "Tipo", value: "TypeAssign" },
                    { text: "Fecha Inicio", value: "AbpStartDateText" },
                    { text: "Fecha Fin", value: "AbpEndDateText" }
                ]
            }
        };
    },

    methods: {
        selectBus(item) {
            this.buss = item;
        },

        hadReturnPerson(value, item) {
            if (value != null) {
                this.NtpFullName = value.NtpFullName;
                this.person.PrsID = value.PrsID;
                
                // Actualizar el PrsID en el item actual
                if (item) {
                    item.PrsID = value.PrsID;
                }
            }else{
                this.NtpFullName = "";
                this.person = { PrsID: null ,};
            }
        },

        save(item) {
            // Validar datos antes de guardar
            if (!item.PrsID && !this.person.PrsID) {
                this.$fun.alert('Por favor seleccione una persona', 'warning');
                return;
            }
            
            if (!item.BscID && !this.buss) {
                this.$fun.alert('Por favor seleccione un bus', 'warning');
                return;
            }
            
            // Asignar valores al item
            item.PrsID = item.PrsID || this.person.PrsID;
            item.BscID = item.BscID || this.buss;
            
            // Si es indefinido, eliminar fechas
            if (item.AbpIsIndefinite) {
                item.AbpStartDate = null;
                item.AbpEndDate = null;
            } else {
                // Validar fechas si no es indefinido
                if (!item.AbpStartDate) {
                    this.$fun.alert('Por favor ingrese una fecha de inicio', 'warning');
                    return;
                }
                
                if (!item.AbpEndDate) {
                    this.$fun.alert('Por favor ingrese una fecha de fin', 'warning');
                    return;
                }
                
                // Validar que fecha fin sea mayor a fecha inicio
                if (new Date(item.AbpStartDate) > new Date(item.AbpEndDate)) {
                    this.$fun.alert('La fecha de fin debe ser mayor a la fecha de inicio', 'warning');
                    return;
                }
            }
            
            // Asignar valores adicionales
            item.SecStatus = 1;
            item.AbpIsIndefinite = item.AbpIsIndefinite ? 1 : 0;
            item.UsrCreateID = this.$fun.getUserID();
            item.UsrUpdateID = this.$fun.getUserID();
            
            // Guardar
            item.save().then(() => {
                this.$fun.alert('Asignación guardada con éxito', 'success');
                this.resetForm();
            }).catch(error => {
                console.error("Error al guardar la asignación:", error);
                this.$fun.alert('Error al guardar la asignación', 'error');
                
            });
        },
        
        resetForm() {
            this.NtpFullName = "";
            this.person = { PrsID: null ,};
        },
        async reportExcel() {
      if (!this.filter.AbpStartDate || !this.filter.AbpEndDate) {
        this.$fun.alert("Debe seleccionar un rango de fechas", "warning");
        return;
      }

      try {
        await ServiceAssignBus
          .exportToExcel(this.filter, this.$fun.getUserID())
          .then((res) => {
            if (res.status !== 200) {
              throw new Error("Error al exportar a Excel");
            }
            const formattedData = this.$fun.formatDataForExcel(
              this.WorkerAsigned.headers,
              res.data
            );

            GenericService.getConvertExcel(formattedData, this.$fun.getUserID()).then(
              (resp) => {
                this.$fun.downloadFileSH(
                  resp.data,
                  this.$const.TypeFile.EXCEL,
                  `Personal_asignado_a_bus_${this.$fun.formatDateView(this.filter.AbpStartDate)}_al_${this.$fun.formatDateView(this.filter.AbpEndDate)}.xlsx`
                );
              }
            );
          });
      } catch (error) {
        this.$fun.alert("Error al exportar a Excel", "error");
      }
    },
    },
    
    created() {
        // Cargar buses
        ServiceMonitoring.list(this.$fun.getUserID())
            .then((r) => {
                this.dataBuses = r.data;
                this.dataBuses.forEach(element => {
                    element.BusRoute = element.BscCompany + ' - ' + element.TypeRouteName
                });

                //seleccionar el primer bus por defecto
                if (this.dataBuses.length > 0) {
                    this.filter.BscID = this.dataBuses[0].BscID;
                    this.buss = this.dataBuses[0].BscID;
                }
            }).catch(error => {
                console.error("Error al cargar buses:", error);
            });
    },
    watch:{
        'filter.AbpStartDate': function(newVal) {
            if (newVal && this.filter.AbpEndDate && new Date(newVal) > new Date(this.filter.AbpEndDate)) {
                this.filter.AbpEndDate = newVal;
            }
        },
        'filter.AbpEndDate': function(newVal) {
            if (newVal && this.filter.AbpStartDate && new Date(newVal) < new Date(this.filter.AbpStartDate)) {
                this.filter.AbpStartDate = newVal;
            }
        }
    }
};
</script>

<style scoped>
.v-text-field {
    margin-top: 0;
}
</style>